// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewproject-btn {
  margin-right: 5px;
  padding: 5px 12px;
  font-size: 13px;
  border-radius: 40px;
  width: 100%;
  background:#fde802;
  border: none;
  cursor: pointer;
}

.viewproject-btn span {
  font-weight: 600;
}

.project-status {
  font-weight: 500;
  border-radius: 20px;
  background:#00c04b;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Projects/project.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".viewproject-btn {\r\n  margin-right: 5px;\r\n  padding: 5px 12px;\r\n  font-size: 13px;\r\n  border-radius: 40px;\r\n  width: 100%;\r\n  background:#fde802;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.viewproject-btn span {\r\n  font-weight: 600;\r\n}\r\n\r\n.project-status {\r\n  font-weight: 500;\r\n  border-radius: 20px;\r\n  background:#00c04b;\r\n  color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
